'use strict';

var { memoize } = require('underscore');

var supportsPositionSticky = memoize(function () {
  // https://github.com/phistuck/Modernizr/commit/3fb7217f5f8274e2f11fe6cfeda7cfaf9948a1f5
  var prop = 'position:',
      value = 'sticky',
      el = document.createElement( 'test' ),
      style = el.style;

  style.cssText = prop + ['-webkit-', '-moz-', '-ms-', '-o-', ''].join(value + ';' + prop) + value + ';';
  return style.position.indexOf(value) !== -1;
});

module.exports = supportsPositionSticky;


/** WEBPACK FOOTER **
 ** ./utils/supportsPositionSticky.js
 **/